function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 6.45645V17.5609C24 17.6726 23.9974 17.7832 23.9916 17.8932C23.8269 21.1473 21.2546 23.7657 18.0218 24H16.5626V14.7292H19.67L20.1684 10.9449H16.5626V8.3144C16.5626 7.57975 17.1577 6.98413 17.8919 6.98413H20.2273V3.58107H16.963C14.6533 3.58107 12.7809 5.45481 12.7809 7.76618V10.9449H9.65873V14.7292H12.7809V24H5.97816C2.74806 23.7657 0.177871 21.152 0.00894619 17.9022C0.00315748 17.789 0 17.6752 0 17.5609V6.45645C0 6.34218 0.00315748 6.22842 0.00894619 6.1152C0.186291 2.70792 3.00276 0 6.45178 0H17.5482C20.9999 0 23.819 2.71266 23.9916 6.12415C23.9974 6.23422 24 6.34481 24 6.45645Z",
  fill: "#4C2C89"
});
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.7ea25b356c512ce2b9df0caa0af239cb.svg";
export { ForwardRef as ReactComponent };